import {
  Root,
  Form,
  FieldsContainer,
  Actions,
  ActionsLeft,
  ActionsRight,
  DeleteButton,
  EditButton,
  CancelButton,
  SubmitButton,
  AutosaveIndicator,
  AiScribe
} from './components';
import {
  NoteType,
  DateOfEncounter,
  StartTime,
  TimeSpent,
  NextContact,
  WhoDidYouReach,
  TypeOfSupport,
  Note,
  DocumentationTime
} from './fields';
import Manager from './fields/manager/manager';
import Chw from './fields/chw/chw';
import Provider from './fields/provider/provider';

// Create Fields namespace
const Fields = {
  NoteType,
  DateOfEncounter,
  StartTime,
  TimeSpent,
  NextContact,
  WhoDidYouReach,
  TypeOfSupport,
  Note,
  DocumentationTime,
  Manager,
  Chw,
  Provider
};

/**
 * NoteForm compound component for composable note editing.
 * The `disabled` state is controlled via the `disabled` prop on Root.
 * Autosave is handled by wrapping content with AutosaveProvider in presets.
 * Note ID is derived from `note?.id` - no need to pass separately.
 *
 * @example
 * // Draft note with autosave (wrap with AutosaveProvider)
 * <NoteForm.Root clientId={clientId} note={note}>
 *   <AutosaveProvider>
 *     <NoteForm.Form>
 *       ...fields
 *     </NoteForm.Form>
 *   </AutosaveProvider>
 * </NoteForm.Root>
 *
 * @example
 * // Final note without autosave
 * <NoteForm.Root clientId={clientId} note={note} disabled={!isEditing}>
 *   <NoteForm.Form>
 *     ...fields
 *   </NoteForm.Form>
 * </NoteForm.Root>
 */
export const NoteForm = {
  Root,
  Form,
  FieldsContainer,
  Fields,
  Actions,
  DeleteButton,
  EditButton,
  CancelButton,
  SubmitButton,
  AutosaveIndicator,
  AiScribe
};

// Also export individual components for tree-shaking
export {
  Root,
  Form,
  FieldsContainer,
  Fields,
  Actions,
  ActionsLeft,
  ActionsRight,
  DeleteButton,
  EditButton,
  CancelButton,
  SubmitButton,
  AutosaveIndicator,
  AiScribe
};

// Export context hooks for advanced usage
export { useNoteFormContext, useAutosaveContext } from './context';

// Export hooks
export { useNoteFormActions, useIsTranscribing } from './hooks';

// Export utils
export { createDefaultValues, remapValues, type NoteFormValues } from './utils';

// Export presets
